import Vue from "vue";
import { functions, api } from "@/firebase.js";

export default {
  state: {
    empleados: 1,
    departamentos: 1,
    tests: 1
  },
  mutations: {
    setFoliosOfCliente(state, folios) {
      state.empleados = folios.empleados;
      state.departamentos = folios.departamentos;
      state.tests = folios.tests;
    }
  },
  actions: {
    ConsultarFoliosOfCliente(context, cliente) {
      console.log(cliente);
      api("getFolios")({
        cliente: cliente
      })
        .then(response => {
          console.log(response.data);
          context.commit("setFoliosOfCliente", response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  getters: {}
};



// WEBPACK FOOTER //
// ./src/modules/folios_cliente.js